export enum MboDossierPermissions {
  MboDossier = 'mbo-dossier',
}
